import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateWarehouseMemberAccessActions as Actions,
  CreateWarehouseMemberAccessRequestAction as RequestAction,
} from 'store/ducks/warehouseMemberAccesses';

export function* createWarehouseMemberAccessRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `warehouse-member-accesses`, postData);
    onSuccess && onSuccess();
    notify('success', 'Acesso ao armazém criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
